
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"346","height":"213","viewBox":"0 0 346 213","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M293.9 117.9h6.4v-8.5h8.4V103h-8.4v-8.4h-6.4v8.4h-8.4v6.4h8.4v8.5z"}}),_c('path',{attrs:{"d":"M334 0H11.5C5.1 0 0 5.1 0 11.3V201c0 6.3 5.2 11.3 11.5 11.3H334c6.4 0 11.5-5.1 11.5-11.3V11.4C345.5 5.1 340.3 0 334 0zM47 119H31.2V93.3H36v21.3h11.2L47 119zm23-9.2c0 6.6-3.5 9.7-10.1 9.7-6.5 0-10.1-3.1-10.1-9.7V93.3h4.7v16.5c0 3.7 1.7 5.3 5.4 5.3s5.3-1.6 5.3-5.3V93.4h4.7l.1 16.4zm25.4 9.2h-3.3l-10.9-15.6-1.5-2.3h-.1v18h-4.2V93.4h4.1l10.2 15 1.5 2.3h.1l-.1-2.7V93.5h4.2V119zm15.9.5c-7.7 0-11.3-4.3-11.3-13.5 0-8.7 3.6-13.1 11.6-13.1 2.1 0 4.5.5 6 1.1l-.5 4.1c-1.3-.5-3.2-.9-5.2-.9-5 0-6.9 2.1-6.9 8.8 0 7 2 9.2 7 9.2 2 0 3.7-.4 5.2-1.1l.5 3.9c-1.8.9-4.2 1.5-6.4 1.5zm30.2-.5h-4.7v-11h-10.4v11h-4.7V93.3h4.7v10.3h10.4V93.3h4.7V119zm14.4-10h-9.5v-3.3h9.5v3.3zm15.1 10.5c-7.7 0-11.3-4.3-11.3-13.5 0-8.7 3.6-13.1 11.6-13.1 2.1 0 4.5.5 6 1.1l-.5 4.1c-1.3-.5-3.2-.9-5.2-.9-5 0-6.9 2.1-6.9 8.8 0 7 1.9 9.2 7 9.2 2 0 3.7-.4 5.2-1.1l.5 3.9c-1.8.9-4.2 1.5-6.4 1.5zm30.1-.5h-4.7v-11H186v11h-4.7V93.3h4.7v10.3h10.4V93.3h4.7V119zm22.6 0h-16.9V93.3h16.4l.1 4.3h-11.8v6.2h10v3.9h-10v7.1h12.3l-.1 4.2zm14.1.5c-7.7 0-11.3-4.3-11.3-13.5 0-8.7 3.6-13.1 11.6-13.1 2.1 0 4.5.5 6 1.1l-.5 4.1c-1.3-.5-3.2-.9-5.2-.9-5 0-6.9 2.1-6.9 8.8 0 7 1.9 9.2 7 9.2 2 0 3.7-.4 5.2-1.1l.5 3.9c-1.7.9-4.1 1.5-6.4 1.5zm25.5-.5l-7.2-11.3h-3.2V119h-4.7V93.3h4.7v10.5h3.3l6.9-10.5h5.5l-8.2 12.2 8.7 13.5h-5.8zm51 4.8h-34.5V88.7h34.5v35.1z"}})])
          )
        }
      }
    